import React, { Component } from 'react'
import ReactToggle from 'react-bootstrap-toggle'
import PropTypes from 'prop-types'

class ToggleField extends Component {
  constructor (props) {
    super(props)
    this.state = { toggleActive: false }
    this.onToggle = this.onToggle.bind(this)
  }

  async onToggle () {
    await this.setState({
      toggleActive: !this.state.toggleActive
    })
    this.props.onChange(this.state.toggleActive)
  }

  async componentWillReceiveProps (nextProps) {
    if (nextProps.checked !== this.props.checked) {
      this.setState({
        toggleActive: nextProps.checked
      })
    }
  }

  async componentDidMount () {
    await this.setState({
      toggleActive: this.props.checked
    })
  }

  render () {
    return (
      <ReactToggle
        onClick={this.onToggle}
        on={<span style={{ fontSize: 10 }}>ON</span>}
        off={<span style={{ fontSize: 10 }}>OFF</span>}
        size='medium'
        offstyle='default'
        onstyle='success'
        active={this.state.toggleActive}
      />
    )
  }
}

ToggleField.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool
}

export default ToggleField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-rate-limits/components/rate-limit-toggle.js